// Maps portal URL paths to permission section keys (longest prefix wins).
export const PATH_SECTION_MAP = [
  ["/job-requests", "job-requests"],
  ["/slas", "slas"],
  ["/jobs", "jobs"],
  ["/emergency-jobs", "emergency-jobs"],
  ["/projects", "projects"],
  ["/quotes", "quotes"],
  ["/work-orders", "work-orders"],
  ["/timeline", "timeline"],
  ["/invoices", "invoices"],
  ["/files", "files"],
  ["/predictive-maintenance", "predictive-maintenance"],
  ["/calendar", "calendar"],
  ["/clients", "clients"],
  ["/tenant-report-forms", "tenant-report-forms"],
  ["/vendors", "vendors"],
  ["/suppliers/nearby", "suppliers-nearby"],
  ["/supplier-compliance", "supplier-compliance"],
  ["/supplier-analytics", "supplier-analytics"],
  ["/supplier-compare", "supplier-compare"],
  ["/supplier-onboarding", "supplier-onboarding"],
  ["/vendor-scorecard", "vendor-scorecard"],
  ["/operative-scorecard", "operative-scorecard"],
  ["/settings/in-house-team", "in-house-team"],
  ["/dispatch-board", "dispatch-board"],
  ["/settings/timesheets", "timesheets"],
  ["/settings/expenses", "expenses"],
  ["/in-house/pos", "in-house-pos"],
  ["/in-house/tracking", "in-house-tracking"],
  ["/in-house/mileage-log", "mileage-log"],
  ["/live-team-map", "live-team-map"],
  ["/ai-assistant", "ai-assistant"],
  ["/portfolio-health", "portfolio-health"],
  ["/compliance-hub", "compliance-hub"],
  ["/document-expiry", "document-expiry"],
  ["/activity-log", "activity-log"],
  ["/reports", "reports"],
  ["/staff-performance", "staff-performance"],
  ["/schedule", "team-schedule"],
  ["/job-forms", "job-forms"],
  ["/settings/checklists", "checklists"],
  ["/templates", "templates"],
  ["/document-templates", "document-templates"],
];

export function sectionKeyForPath(pathname) {
  if (!pathname) return null;
  if (pathname === "/") return "dashboard";
  let best = null, bestLen = -1;
  for (const [prefix, key] of PATH_SECTION_MAP) {
    if ((pathname === prefix || pathname.startsWith(prefix + "/")) && prefix.length > bestLen) {
      best = key;
      bestLen = prefix.length;
    }
  }
  return best;
}
